import type { ParsedPublicMessage } from '@module/types/centrifuge/messageTypes';
import {
  isServiceCastBlockMessage,
  type ServiceCastBlockMessage,
} from '@module/types/centrifuge/public-message/serviceMessageTypes';
import type { MessageHandler, MessageHandlerAction, MessageHandlerContext } from '../types';

export class ServiceCastBlockHandler implements MessageHandler {
  constructor(private customAction?: MessageHandlerAction<ServiceCastBlockMessage>) {}

  canHandle(payload: ParsedPublicMessage): boolean {
    return isServiceCastBlockMessage(payload);
  }

  handle(payload: ServiceCastBlockMessage, context: MessageHandlerContext): void {
    if (this.customAction === null || this.customAction === undefined) return;

    if (typeof this.customAction === 'function') {
      this.customAction(payload, context);
      return;
    }

    // 기본 동작
    context?.getOutOfRoom?.('配信が終了しました。'); // 방송이 종료 되었습니다.
  }
}
